import { Route, Routes } from 'react-router-dom';
import CreatePipelineWithGuard from './CreatePipeline/CreatePipelineWithGuard';
import PipelineOverview from './PipelineOverview/components/PipelineOverview';
import EditPipeline from './EditPipeline/EditPipeline';
import { PipelineEditSource } from './PipelineOverview/components/PipelineEditSource/PipelineEditSource';
import { PipelineEditDestination } from './PipelineOverview/components/PipelineEditDestination/PipelineEditDestination';
import { LazyPipelineList } from './PipelineList/LazyPipelineList';

export default function Pipelines() {
  return (
    <Routes>
      <Route path='/' element={<LazyPipelineList />} />
      <Route path='/:id/create' element={<CreatePipelineWithGuard />} />
      <Route path='/:id/edit' element={<EditPipeline />} />
      <Route path='/:id/edit-source' element={<PipelineEditSource />} />
      <Route path='/:id/edit-destination' element={<PipelineEditDestination />} />
      <Route path='/:id/*' element={<PipelineOverview />} />
    </Routes>
  );
}
